import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

export function prefixUrl(path: string): string {
  let url = path;
  if (!/^(https|http|blob)?:/i.test(path)) {
    url = environment.serverUrl + (path.startsWith('/oauth/') ? '' : '/v2') + path;
  }
  return url;
}

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({ url: prefixUrl(request.url) });
    return next.handle(request);
  }
}
